import React, { Component } from 'react';
import { Alert, Button, Col, Form, Row, message } from 'antd';
import { string, object, number } from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import API from '../../../api';
import { history } from '../../common/custom-router';
import PropertyAttributes from '../sale-process-form/property-attributes';
import ClientAttributes from '../sale-process-form/client-attributes';
import { getErrorElement } from '../../../utils/form';

class PreSaleForm extends Component {
  static propTypes = {
    action: string,
    preSale: object,
    currentUserId: number
  };

  state = {
    error: null
  };

  handleSubmit = (values) => {
    const { action, preSale } = this.props;
    this.setState({ error: null });

    const attributes = this.getPreSaleAttributes(values);

    let request;

    if (action === 'create') {
      request = API.staff.createPreSale(attributes).then(() => {
        message.success('Pre-venta creada');
        history.push('/staff/pre_sales');
      });
    } else {
      request = API.staff.updatePreSale(preSale.id, attributes).then(() => {
        message.success('Pre-venta actualizada');
        history.push('/staff/pre_sales');
      });
    }

    request.catch((error) => {
      this.setState({ error: getErrorElement(error) });
    });
  };

  getPreSaleAttributes = (values) => {
    const { action, preSale } = this.props;
    const {
      addressAttributes,
      buyerAttributes,
      sellerAttributes,
      tags,
      ...rest
    } = values;

    const formattedAddress = this.formatAddressAttributes(addressAttributes);
    const formattedBuyer = this.formatClientPayload(buyerAttributes);
    const formattedSeller = this.formatClientPayload(sellerAttributes);

    const attributes = {
      ...rest,
      tags,
      addressAttributes: formattedAddress
    };

    if (buyerAttributes.id) {
      attributes.buyerId = buyerAttributes.id;
    } else if (formattedBuyer) {
      attributes.buyerAttributes = formattedBuyer;
    }

    if (sellerAttributes.id) {
      attributes.sellerId = sellerAttributes.id;
    } else if (formattedSeller) {
      attributes.sellerAttributes = formattedSeller;
    }

    if (action === 'edit' && preSale) {
      attributes.addressAttributes = {
        id: preSale.address?.id,
        ...attributes.addressAttributes
      };
    }

    return attributes;
  };

  formatAddressAttributes = (attributes = {}) => {
    const { regionCommune, ...rest } = attributes || {};

    if (!regionCommune || regionCommune.length === 0) {
      return rest;
    }

    return {
      ...rest,
      region: regionCommune[0],
      commune: regionCommune[1]
    };
  };

  formatClientPayload = (attributes = {}) => {
    const { id, regionCommune, rut, ...rest } = attributes;

    if (id) {
      return { id };
    }

    if (!rut) {
      return undefined;
    }

    return {
      ...rest,
      rut,
      region: regionCommune && regionCommune[0],
      commune: regionCommune && regionCommune[1]
    };
  };

  getInitialValues = () => {
    const { preSale, currentUserId } = this.props;

    const baseClient = {
      interestedEmails: [],
      regionCommune: []
    };

    if (!preSale) {
      return {
        supervisorId: currentUserId,
        tags: [],
        addressAttributes: {
          regionCommune: []
        },
        buyerAttributes: baseClient,
        sellerAttributes: baseClient
      };
    }

    const { address, seller, buyer } = preSale;

    return {
      ...preSale,
      tags: preSale.tags || [],
      addressAttributes: address
        ? {
          id: address.id,
          street: address.street,
          number: address.number,
          complement: address.complement,
          complementType: address.complementType,
          extraLine: address.extraLine,
          regionCommune: address.region && address.commune ? [address.region, address.commune] : []
        }
        : { regionCommune: [] },
      buyerAttributes: this.formatClientInitialValues(buyer, baseClient),
      sellerAttributes: this.formatClientInitialValues(seller, baseClient)
    };
  };

  formatClientInitialValues = (client, baseClient) => {
    if (!client) {
      return baseClient;
    }

    return {
      ...client,
      interestedEmails: client.interestedEmails || [],
      regionCommune: client.region && client.commune ? [client.region, client.commune] : []
    };
  };

  render () {
    const { action } = this.props;
    const { error } = this.state;

    return (
      <>
        {
          error && (
            <Alert
              message="Error al guardar la pre-venta"
              description={error}
              type="error"
              style={{ marginBottom: 16 }}
              closable
            />
          )
        }
        <Form
          layout="vertical"
          initialValues={this.getInitialValues()}
          onFinish={this.handleSubmit}
          ref={(ref) => { this.form = ref; }}
          hideRequiredMark
          autoComplete="off"
        >
          <Row gutter={4}>
            <PropertyAttributes
              processTypes={[]}
              hideProcessType
              action={action}
            />
            <ClientAttributes getForm={() => this.form} seller/>
            <ClientAttributes getForm={() => this.form} buyer/>
            <Col span={24}>
              <div className="d-flex flex-row justify-content-end">
                {
                  action === 'create' && (
                    <Link to='/staff/pre_sales'>
                      <Button type="secondary" className="mr-2">
                        Cancelar
                      </Button>
                    </Link>
                  )
                }
                <Button type="primary" htmlType="submit">
                  { action === 'create' ? 'Crear' : 'Guardar' }
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUserId: state.session.currentUser.id
});

export default connect(mapStateToProps)(PreSaleForm);
